/**
 * Workflows Module Configuration
 *
 * Manages automated workflow rules: triggers, conditions, and actions.
 * Hidden from top-level sidebar — accessed via Settings navigation group.
 */

import type { AppModule } from '@/types/architecture'
import routes from './routes'

const workflowsModule: AppModule = {
    id: 'workflows',

    navigation: {
        label: 'Workflows',
        icon: 'git-branch',
        path: '/workflows',
        order: 94,
        moduleKey: 'settings.workflows',
        showInSidebar: false, // Accessed via Settings group


        pages: [
            {
                label: 'All Workflows',
                path: '/workflows',
            },
            {
                label: 'Dead Letter',
                path: '/workflows/dead-letter',
            },
            {
                label: 'Create Workflow',
                path: '/workflows/create',
            },
        ],
    },

    routes,
}

export default workflowsModule
